import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from "@angular/http";

import config from "../../config/config";

/**
 * Generated class for the AuxilioListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-auxilio-list',
  templateUrl: 'auxilio-list.html',
})
export class AuxilioListPage {
  itens: any = []
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public navParams: NavParams
    ) {}

  ionViewDidLoad() {
    this.listar();
  }
  listar(){


    this._http
      .get(config.urlAPI + "auxilios/tudo", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
       
        // console.log(res);
        // res.map(res => this.traducao(res.tipodeauxilio))
        res.map(obj => {
          if (obj.tipodeauxilio == "N" || obj.tipodeauxilio == "n") {
            obj.tipodeauxilio =  "Nascimento";
            
          } else {
            obj.tipodeauxilio = "Falecimento";
          }
          obj.datadoauxilio = obj.datadoauxilio.slice(0,10);
        })
        res.reverse();
        this.itens = res;
        
        
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/auxilio-list/auxilio-list.ts